import { useCallback, useEffect, useState } from 'react';
import { isServer } from '../utils/environment';

const getSearchParams = () => {
  if (isServer()) return new URLSearchParams();
  return new URLSearchParams(window.location.search);
};

export const useSearchParams = (): [
  URLSearchParams,
  (params: URLSearchParams) => void,
] => {
  // Get the current location's search params
  const [searchParams, setSearchParams] = useState(getSearchParams());

  // Function to update search params
  const updateSearchParams = useCallback((searchParams: URLSearchParams) => {
    // Update the URL
    const newUrl =
      searchParams.size > 0
        ? `${window.location.pathname}?${searchParams.toString()}`
        : window.location.pathname;
    window.history.pushState({}, '', newUrl);

    // Update the state
    setSearchParams(searchParams);
  }, []);

  // Effect to sync state with URL changes
  useEffect(() => {
    const handlePopState = () => {
      setSearchParams(new URLSearchParams(window.location.search));
    };

    // Listen for popstate event to update searchParams when the URL changes
    window.addEventListener('popstate', handlePopState);

    // Cleanup
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return [searchParams, updateSearchParams];
};
